import { propertyOf, sortBy } from 'lodash-es';
import {
  ADVANCE_ORDER_BADGE_TEXT,
  ADVANCE_ORDER_TAG,
  BADGE_ORDER,
  COMING_SOON_TAG,
  HIDDEN_INVENTORY_TAG,
  CANNOT_SHIP_OUTSIDE_US_TAG,
  SUPPRESS_BADGE_BELOW_SWATCH,
  BEAUTY_SHIPPING_RESTRICTIONS_TAG,
  CANNOT_SHIP_TO_EEA_TAG,
} from './constants';
import { ShippingCountryState } from './shipping';
import { doesCountryBanAloBeauty, isCodeInEEA } from './location';
import { isTagPresent } from './helpers';

export const isComingSoon = (tags: string[] | undefined) => {
  if (!tags) return;
  return isTagPresent(tags, COMING_SOON_TAG);
};

export const productBadgeText = (tags: string[], hasInventory: boolean) => {
  if (tags && tags.length < 1) return null;
  const filteredTags = tags?.filter((tag) => tag.toLowerCase().startsWith('b:') || tag === ADVANCE_ORDER_TAG);
  const sortedTags = sortBy(filteredTags, propertyOf(BADGE_ORDER));
  let firstTag = sortedTags.shift();
  if (firstTag === ADVANCE_ORDER_TAG) {
    if (hasInventory && !isTagPresent(tags, HIDDEN_INVENTORY_TAG)) {
      return ADVANCE_ORDER_BADGE_TEXT;
    } else {
      firstTag = sortedTags.shift();
    }
  }
  return firstTag?.slice(4) || null;
};

// supply the correct copy for products that have no inventory i.e. 'coming soon' or 'sold out'
export const getSoldOutCopy = (tags: string[] | undefined, isASet?: boolean) => {
  if (!tags) return;
  return `Sold Out${!isASet ? ` Online` : ''}`;
};

export const handleBadge = (tags: string[], hasInventory: boolean) => {
  const suppressBadgeBelowSwatch = isTagPresent(tags, SUPPRESS_BADGE_BELOW_SWATCH);
  const badge = productBadgeText(tags, hasInventory);
  if (!badge || suppressBadgeBelowSwatch) {
    return '';
  }
  let selectedBadge = badge.toLowerCase();
  if (selectedBadge.startsWith('embody') || selectedBadge.toLowerCase() === 'sale exclusion') return '';
  if (selectedBadge.startsWith('new')) return 'New';
  return badge || '';
};

export const hasHiddenInventoryTag = (tags: string[] | undefined) => {
  return tags ? isTagPresent(tags, HIDDEN_INVENTORY_TAG) : false;
};

const ineligibleSwatchTypes = ['beauty', 'wellness', 'books', 'gift card', 'alo moves', 'sets'];

export const determineSwatchEligibility = (productType: string) => {
  const lowerCaseProductType = productType.toLowerCase().split(':');
  if (lowerCaseProductType[0]?.startsWith('accessories')) {
    return lowerCaseProductType[1]?.includes('jewelry');
  } else if (lowerCaseProductType[0]) {
    return ineligibleSwatchTypes.includes(lowerCaseProductType[0]);
  }
};

export const hasCannotBeShippedOutsideUSTag = (tags: string[]) => {
  return isTagPresent(tags, CANNOT_SHIP_OUTSIDE_US_TAG);
};

export const determineATCandWishlistEligibility = (selectedProductTags: string[]) => {
  const { country } = ShippingCountryState;
  const geoRestrictionConditions: [policyTag: string, associatedGeoCheck: boolean][] = [
    [CANNOT_SHIP_TO_EEA_TAG, country?.code ? isCodeInEEA(country?.code) : false],
    [BEAUTY_SHIPPING_RESTRICTIONS_TAG, country?.code ? doesCountryBanAloBeauty(country?.code) : false],
    [CANNOT_SHIP_OUTSIDE_US_TAG, country?.code ? country?.code !== 'US' : false],
  ];
  return selectedProductTags.some((tag) => {
    const lowercaseTag = tag.toLowerCase();
    return geoRestrictionConditions.some(([policyTag, geoConditionMatches]) => {
      const lowercasePolicyTag = policyTag.toLowerCase();
      return lowercasePolicyTag.includes(lowercaseTag) ? geoConditionMatches : false;
    });
  });
};
